const T0 = 1772323200; // 2026-03-01 00:00:00 UTC
const D = 86400;

export const demoTimestamps = Array.from(
  { length: 60 },
  (_, i) => T0 + i * 12 * 3600
);

// Une valeur par point (60 points, toutes les 12 h à partir du 2026-03-01)
export const demoY = [
  88.0, 105.9, 108.2, 100.9, 93.1, 92.3, 102.3, 112.8, 105.5, 80.1, 60.3, 63.1,
  76.2, 79.1, 70.0, 61.6, 61.8, 72.0, 90.1, 105.3, 104.9, 93.4, 90.8, 103.5,
  113.7, 106.1, 88.6, 76.5, 72.8, 72.5, 73.4, 72.1, 64.6, 58.4, 66.3, 85.2,
  96.2, 92.5, 89.1, 97.2, 400.0, 110.9, 105.1, 95.6, 84.9, 78.2, 80.1, 82.6,
  72.6, 56.1, 53.2, 68.7, 84.6, 87.2, 83.1, 83.7, 91.2, 103.3, 115.1, 115.8,
];

export const demoDonnees = [
  {
    name: 'Niveau sonore — Capteur A-03',
    color: '#7b2fa8',
    t: demoTimestamps,
    x: demoTimestamps,
    y: demoY,
    sensor_name: 'A-03',
    prefix: 'dB',
    mode: 'lines',
    line: { color: '#7b2fa8', width: 2, shape: 'spline', smoothing: 0.6 },
  },
];

// Labels — marqueurs ponctuels avec iconType = clé de EVENT_STYLES
export const demoLabels = [
  {
    t: T0 + 2 * D,
    iconType: 'pelleuse',
    label: 'Excavatrice',
    note: 'Excavation rue Gambetta',
    precision: 87,
    urlSon: 'https://www.demo.com/sound/marteau.mp3',
  },
  {
    t: T0 + 8 * D,
    iconType: 'compresseur',
    label: 'Compresseur A',
    note: 'Compresseur chantier A',
    precision: 92,
   urlSon: 'https://www.demo.com/sound/marteau.mp3',
  },
  {
    t: T0 + 15 * D,
    iconType: 'circulation',
    label: 'Trafic matinal',
    note: 'Pic trafic matin',
    precision: 78,
   urlSon: 'https://www.demo.com/sound/marteau.mp3',
  },
  {
    t: T0 + 20 * D,
    iconType: 'panne',
    label: 'Pic anormal',
    note: 'Valeur 400 dB',
    precision: 64,
  },
  {
    t: T0 + 25 * D,
    iconType: 'marteau_piqueur',
    label: 'Marteau',
    note: 'Marteau-piqueur chantier B',
    precision: 95,
    urlSon: 'https://www.demo.com/sound/marteau.mp3',
  },
];

// Sections — plages temporelles colorées en fond (à personnaliser)
export const demoSections = [
  {
    tStart: T0,
    tEnd: T0 + 10 * D,
    label: 'Phase 1 — Terrassement',
    color: '#e07b00',
  },
  {
    tStart: T0 + 10 * D,
    tEnd: T0 + 15 * D,
    label: 'Phase 2 — Fondations',
    color: '#0077b6',
  },
  {
    tStart: T0 + 15 * D,
    tEnd: T0 + 25 * D,
    label: 'Phase 3 — Finitions',
    color: '#26b36a',
  },
];

export const demoConfiguration = {
  subtitle: 'Niveau sonore capteur A-03 — Mars 2026',
  xaxis: { title: 'Temps' },
  yaxis: { title: 'Niveau sonore (dB)' },
  labels: demoLabels,
  sections: demoSections,
};

export const demoDonneesGraphe = (graph_type_id, title) => ({
  config: { graph_type_id, title, sensor_name: 'A-03', prefix: 'dB' },
  data: demoDonnees,
});
